import React from 'react';
import ContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary';

const withContainerErrorBoundary = (WrappedComponent, key) => {
  const containerErrorBoundaryHigherOrderComponent = props => (
    <ContainerErrorBoundary key={ key } origin={ key }>
      <WrappedComponent { ...props } />
    </ContainerErrorBoundary>
  );
  return containerErrorBoundaryHigherOrderComponent;
};

export default withContainerErrorBoundary;
